// Vendor imports
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import breakpoint from 'alpinejs-breakpoints'
import form from "./form";

Alpine.data('form', form);

Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)

window.Alpine = Alpine
window.AlpineBreakpointPluginBreakpointsList = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
	'3xl',
	'max',
	'wide',
]

Alpine.start()

import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/svgIconSprite'
// import WorkFilter from './modules/workFilter'

import './modules/gsap'
import './modules/carousel'
import './modules/vimeoHover'
import './modules/fancyapps'

// Initialize work filter on work listing pages
// document.addEventListener('DOMContentLoaded', () => {
    // if (document.querySelector('.filter-btn')) {
    //     new WorkFilter();
    // }
// })

document.querySelectorAll('[href="#contact"]').forEach(button => {
	button.addEventListener("click", (e) => {
		e.preventDefault();
		window.dispatchEvent(new CustomEvent('modal', { open: true }))
	})
})
